import React from 'react';
import { BookOpen, MessageSquare, Clock, Smartphone, ShieldAlert } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Card } from './ui/Card';
export function IncludesSection() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-[#00d9ff]" data-id="element-172" />,
    title: 'Manual Maestro Protocolo Ex-Back AI',
    desc: 'La estrategia completa paso a paso. El núcleo del sistema.'
  }, {
    icon: <MessageSquare className="w-8 h-8 text-[#00d9ff]" data-id="element-173" />,
    title: "5 Plantillas 'Rompehielo'",
    desc: 'Mensajes exactos para copiar y pegar según tu situación específica.'
  }, {
    icon: <Clock className="w-8 h-8 text-[#00d9ff]" data-id="element-174" />,
    title: 'La Regla del Espejo',
    desc: 'El algoritmo de tiempo y longitud para no verte nunca más necesitado/a.'
  }, {
    icon: <Smartphone className="w-8 h-8 text-[#00d9ff]" data-id="element-175" />,
    title: 'Auditoría de Perfil Digital',
    desc: 'Qué borrar y qué publicar hoy para generar curiosidad instantánea.'
  }, {
    icon: <ShieldAlert className="w-8 h-8 text-[#00d9ff]" data-id="element-176" />,
    title: 'Guía de FAQ de Emergencia',
    desc: 'Respuestas directas para los momentos de crisis a medianoche.'
  }];
  return <section className="py-20 relative" data-id="element-177">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <FadeIn data-id="element-179">
          <div className="text-center mb-16" data-id="element-180">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-181">
              Lo que obtienes hoy
            </h2>
            <div className="w-24 h-1 bg-[#00d9ff] mx-auto rounded-full" data-id="element-182" />
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-183">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === 3 ? 'lg:col-start-1 lg:col-span-1' : index === 4 ? 'lg:col-start-2 lg:col-span-2' : ''} data-id="element-184">
              <Card hoverEffect glowColor="cyan" className="h-full flex flex-col items-center text-center group" data-id="element-185">
                <div className="w-16 h-16 rounded-2xl bg-[#00d9ff]/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-[#00d9ff]/20" data-id="element-186">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-187">
                  {item.title}
                </h3>
                <p className="text-gray-400" data-id="element-188">{item.desc}</p>
              </Card>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}